import useSVG from "../../../hooks/useSVG";
function PoweredBy({ goToScheduler }) {
    const { UseMainSVG } = useSVG();

    return (
        <div id="v-pt-slider-5" className="v-pt-slides">
            <div id="v-pt-s5-header">{UseMainSVG("logo")}</div>

            <div id="v-pt-s5-body">
                <h2>Get Moving with</h2>
                <h2 className="orange">Expert Care</h2>
                <h2>Virtually Anywhere</h2>

                <div id="v-pt-s5-pb">
                    <p>POWERED BY</p>
                    <img src="assets/images/virtualPT/brg-logo.png" />
                </div>
            </div>
        </div>
    );
}

export default PoweredBy;
